import React from 'react';
import { StatisticCard } from '../StatisticCard/StatisticCard';
import { useCalculateTotalPathDistance } from 'entities/navigation/hooks';
import { useIntl } from 'react-intl';

export const DistanceCard = () => {
  const totalDistance = useCalculateTotalPathDistance();
  const { formatMessage } = useIntl();

  return (
    <StatisticCard
      iconKind="road"
      primaryText={`${totalDistance} km`}
      secondaryText={formatMessage({ id: 'distance' })}
    />
  );
};
